module.exports = __webpack_public_path__ + "img/hopways.ef5c6060.jpeg";